import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportersInfoComponent } from './supporters-info.component';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [SupportersInfoComponent],
  exports: [SupportersInfoComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SupportersInfoModule { }
